// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FlightsListing } from 'types/search/listings/offer';
import { InlineAdConfig } from 'src/types/search/listings/inline-ad-config';

export const shouldMesoInlineAdRender = (config: InlineAdConfig, offerIndex: number): boolean =>
  Object.keys(config.slots).indexOf(offerIndex.toString()) > -1;

export const getInlineAdOffsetDelta = (offer: FlightsListing): number =>
  Number(
    offer.__typename !== 'FlightsBargainFareOffer' &&
      (offer.__typename !== 'FlightsStandardOffer' || Boolean(offer.sponsoredAirline))
  );
